export const LINK_LOGIN = '/link_login';
